module.exports = __webpack_public_path__ + "static/hell-step1-9bdaf463de338b957ab42c8663508708.png";